import type { Audience, ContentBundle, Locale } from "./types";

const BASE = "/api/v1";

async function get<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      Accept: "application/json",
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new Error(`API ${res.status}: ${detail || res.statusText}`);
  }
  return (await res.json()) as T;
}

export function fetchLocales(): Promise<Locale[]> {
  return get<Locale[]>("/locales");
}

export function fetchAudiences(locale: string): Promise<Audience[]> {
  const q = new URLSearchParams({ locale }).toString();
  return get<Audience[]>(`/audiences?${q}`);
}

export function fetchContent(
  audience: string,
  locale: string,
  tone: "soft" | "direct",
): Promise<ContentBundle> {
  const q = new URLSearchParams({ locale, tone }).toString();
  return get<ContentBundle>(`/content/${encodeURIComponent(audience)}?${q}`);
}
